import {FC, memo, PropsWithChildren, useEffect, useState} from 'react'
import css from './index.module.less';

export const UserAgreement: FC = memo(props => {

  return (
    <div className={css.Page}>
     <h3> 广游客服中心服务条款</h3>

      <p>发布日期： 2023年 4 月 6日</p>

      <p>1. 服务概述</p>

      <p>本服务条款是用户（您）与金华万合晶科技有限公司（下称“我们”）之间的协议。</p>

      <p>1.1 重要须知：在此特别提醒，用户（您）欲访问和使用广游客服中心（以下简称“本中心”）所提供的服务，必须事先认真阅读本服务条款中各条款。请您审阅并选择接受或不接受本服务条款（未成年人审阅时应得到法定监护人的陪同）。如您不同意本服务条款及/或随时对其的修改，您应不使用或主动取消我们提供的服务。您的使用行为将被视为您对本服务条款全部的完全接受，包括接受我们对服务条款随时所做的任何修改。</p>

      <p>1.2 广游客服中心服务条款(以下简称"本服务条款")可由我们随时更新，修改后的条款一旦在网页上公布即有效代替原来的服务条款。您可随时查阅最新版服务条款。</p>

      <p>1.3 本中心目前为多款游戏提供客户服务。当您使用我们某一特定客户服务时，如该服务另有单独的服务条款、指引或规则，您应遵守本服务条款及我们随时公布的与该服务相关的服务条款、指引或规则等。前述所有的指引和规则，均构成本服务条款的一部分。</p>

      <p>1.4 本中心经合法授权接入了多款游戏，您可以在游戏内直接登入或可以通过游戏内账号及密码登入；但需注意由于部分游戏与我们的登录系统不兼容，您需要通过注册登入。</p>

      <p>1.5 本中心作为第三方客户服务平台，根据游戏发行商或运营商的授权代为接收您的需求，发行商或运营商依据您提供的信息按其相关规则处理后，由我们为您提供反馈。如您因使用游戏发行商或运营商提供的产品或服务而产生争议、纠纷等，本中心不承担法律责任。</p>

      <p>2. 用户使用规则</p>

      <p>2.1 本中心仅提供软件技术支持，您必须自行配备上网和使用电信增值业务所需的设备，自行负担个人上网或第三方（包括但不限于电信或移动通信提供商）收取的通信费、信息费等有关费用，我们不收取相关费用。</p>

      <p>2.2 除您与我们另有约定外，您同意本服务条款所有内容，您不可对本中心所提供服务的任何部分或服务代码进行出售，或利用本服务进行调查、广告、或用于其他商业目的，其中，您不得将任何广告信函与信息、促销资料、垃圾邮件与信息、滥发邮件与信息、直销及传销邮件与信息以网络电话、短信、彩信、邮件、即时通信、文件分享或以其他方式传送。</p>

      <p>2.3 您在使用产品中不得通过本中心相关服务发送任何妨碍社会治安或非法、虚假、骚扰性、侮辱性、恐吓性、伤害性、破坏性、挑衅性、庸俗性、淫秽色情性等内容的信息，一旦发现将立即停止对其服务，同时，我们不承担相关法律责任。</p>

      <p>2.4 您需保证自己在使用各服务时身份的真实性和正确性及完整性，如果资料发生变化，您应及时更改。在安全完成本服务的登记程序并后，您应维护密码及账号的机密安全。您应对任何人利用您的密码及账号所进行的活动负完全的责任，我们无法对非法或未经您授权使用您账号及密码的行为作出甄别，因此我们不承担任何责任。</p>

      <p>2.5您不得使用任何第三方软件或其他不当方式篡改、利用本中心运行程序干扰其他用户正常使用服务、获取其他用户个人信息、制作虚假信息、谋取不正当利益等。如违反上述规则，一经发现，我们将追究您的法律责任；如造成我们、合作公司或第三方损失的，您应承担全部赔偿责任。</p>

      <p>2.6 您需要严格遵守所在国家的有关法律、法规和行政规章制度。如您违反所在国家法律法规或本服务条款，我们和合作公司将有权停止向您提供服务而不需承担任何责任，如导致我们或合作公司遭受任何损害或遭受任何来自第三方的纠纷、诉讼、索赔要求等，您须向我们或合作公司赔偿相应的损失，您并需对其违反服务条款所产生的一切后果负全部法律责任。</p>

      <p>3. 服务风险及免责声明</p>

      <p>3.1 您须明白，本服务仅依其当前所呈现的状况提供，本服务涉及到互联网等服务，可能会受到各个环节不稳定因素的影响。因此服务存在因上述不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机、通信网络、自身网络安全设置、互联网络原因等造成的服务中断或不能满足用户要求的风险。开通服务的用户须承担以上风险，我们和合作公司对服务之及时性、安全性、准确性不作担保，对因此导致用户不能发送和接受阅读消息、或传递错误，个人设定之时效、未予储存或其他问题不承担任何责任</p>

      <p>3.2 本中心发生突发故障影响到服务的正常运行，我们承诺在第一时间内与相关单位配合，及时处理进行修复。但用户因此而产生的经济损失，我们和合作公司不承担责任。此外，我们保留不经事先通知为维修保养、升级或其他目的暂停本服务任何部分的权利。</p>

      <p>3.3 关于使用及储存之一般措施：您承认关于本服务的使用我们有权制订一般措施及限制，包含但不限于本服务将保留用户个人信息、电子邮件信息、所上载内容之最长期间、本服务一个账号当中可收发电子邮件等的最大数量、本服务一个账号当中可收发的单个信息或电子邮件的大小、服务器为您分配的使用空间，以及一定期间内您使用本服务之次数上限（及每次使用时间之上限）。</p>

      <p>3.4 链接服务：本中心或第三方可提供与其他国际互联网上之网站或资源之链接。由于本中心无法控制这些网站及资源，您了解并同意：无论此类网站或资源是否可供利用，我们不予负责；我们也对存在或源于此类网站或资源之任何内容、广告、产品或其他资料不予保证或负责。因您使用或依赖任何此类网站或资源发布的或经由此类网站或资源获得的任何内容、商品或服务所产生的任何损害或损失，我们不负任何直接或间接之责任。若您认为该链接所载的内容侵犯您的权利，我们声明与上述内容无关，不承担任何责任。我们建议您与该网站或法律部门联系，寻求法律保护。</p>

      <p>3.5 您保证在使用我们提供的产品和服务时遵守相关法律规定，对信息内容的准确性、安全性与合法性负责。违法信息主要是指您违反您所在国家法律法规、社会公共利益的信息，包括但不限于以下情形：</p>

      <p>3.5.1 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>

      <p>3.5.2 有损国家荣誉、利益的；</p>

      <p>3.5.3 违反国家民族政策和宗教政策的信息内容，如，煽动民族仇恨、民族歧视、破坏民族团结的；</p>

      <p>3.5.4 破坏国家宗教政策，宣扬法轮功等邪教和封建迷信等有损于社会秩序、社会治安、社会公共道德和侵害他人合法权益的信息内容；</p>

      <p>3.5.5 散布谣言，扰乱社会秩序的，破坏社会稳定的；</p>

      <p>3.5.6 散布淫秽、色情、赌博、暴力、凶杀、恐怖、诈骗或教唆犯罪的；</p>

      <p>3.5.7 侮辱或诽谤他人，侵犯他人合法权益的；</p>

      <p>3.5.8 煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；</p>

      <p>3.5.9 发布反社会、反政府、谣言、诈骗及不实信息内容的；</p>

      <p>3.5.10 进行金融诈骗，如借贷、发票、催款等表现形式的；</p>

      <p>3.5.11 进行违法行为或违反公序良俗活动的；</p>

      <p>3.5.12 以非法民间组织名义活动的；</p>

      <p>3.5.13 含有虚假、欺诈、诱导您的用户内容的；</p>

      <p>3.5.14 含有提供非法产品或服务的；</p>

      <p>3.5.15 以攻击、骚扰等方式引起您的用户投诉的；</p>

      <p>3.5.16 恶意骚扰您的用户的；</p>

      <p>3.5.17 含有法律、行政法规禁止的其他内容的。</p>

      <p>3.6 由于通信网络或第三方机房服务器资源或硬件设备引起的中断、无法运作、标记、迟延履行、条款变更或计算机错误、病毒感染、黑客攻击、信息损坏、数据丢失或其它在服务提供者合理控制范围之外的原因导致本服务无法正常使用时，我们不就由此产生的损失或破坏而向您或您的用户及其他任何第三方承担赔偿责任。</p>

      <p>4. 服务变更、中断或终止及服务条款的修改</p>

      <p>4.1 我们有权在必要时修改本服务条款，一旦发生变动，将会公布修改后的服务条款。如果不同意所改动的内容，您应主动取消此项服务或与我们取得联系。如果您继续使用服务，则视为接受服务条款的变动。</p>

      <p>4.2 我们特别提醒您注意，为了保障公司业务发展和调整的自主权，我们拥有未经事先通知而修改服务内容、中断或中止部分或全部服务的权利，修改会以通告形式公布于本中心相关页面上，一经公布视为通知。</p>

      <p>4.3 如发生下列任何一种情形，我们有权随时中断或终止向用户提供服务而无需通知用户：</p>

      <p>4.3.1 用户提供的资料不真实；</p>

      <p>4.3.2 用户违反本服务条款的规定；</p>

      <p>4.3.3 按照行政主管或监管部门的要求；</p>

      <p>4.3.4 其他我们认为是符合整体服务需求的特殊情形。</p>

      <p>5. 用户隐私保护条款</p>

      <p>5.1 我们重视对用户隐私的保护，详细情况请参见我们的《隐私政策》。您提供的登记资料及我们保留的有关您的若干其他个人资料将受到中国有关隐私的法律条款之约束。</p>

      <p>5.2 您使用我们服务时，我们有权用数字代码、通用唯一标识符、cookies或其他技术确定进入服务的设备。我们有可能利用所得信息对服务的使用进行总体性及匿名的数据统计及分析，所得数据可供我们使用。</p>

      <p>5.3 我们可能会与第三方合作向您提供相关的服务，如该第三方（如云服务器储存商）为合法经营的公司且提供同等的用户隐私保护，我们有权将您的资料等提供给该第三方。</p>

      <p>5.4 您自行取得或从第三方处取得数据不得侵犯个人隐私，或已充分经过第三方的授权，否则由此导致的责任由您自行承担。</p>

      <p>5.5 如果您违反与数据和信息保护相关规定，您应承担相应的法律后果，由此给我们造成损失的，您需要承担赔偿责任。</p>

      <p>6. 知识产权及法律保护条款</p>

      <p>6.1 知识产权相关信息内容包括：文字、软件、声音、相片、录像、图表；网页及我们向您提供的具有商业价值的信息。所有上述内容受版权、商标权、和其它知识产权和所有权法律的保护。所以，您只能在我们或相关权利人授权下才能使用这些内容，而不能擅自使用、抄袭、复制、修改、编撰这些内容、或创造与内容有关的衍生产品。</p>

      <p>6.2 关于我们提供的软件和服务：您了解并同意，本服务及本服务所使用或提供之相关软件（但不包括两用户之间直接传递的资料）是由我们拥有所有相关知识产权及其他法律保护之权利（包括但不限于版权、商标权、专利权、及商业秘密）的资料。</p>

      <p>7. 争议解决</p>

      <p>本服务的实际提供地为广州市天河区，如果您与本公司发生争议，您同意将争议提交至广州市天河区人民法院通过诉讼的方式解决。</p>

      <p>8. 通知条款</p>
      <p>我们提供服务项下所有的通知均可通过您提供的电子邮箱和手机短信、本中心消息推送、游戏内系统提示的方式进行。该等通知于发送之日视为已送达收件人。</p>

      <p>9. 其他条款</p>

      <p>9.1如本服务条款中的任何条款无论因何种原因完全或部分无效或不具有执行力，本服务条款的其余条款仍应有效且具有约束力。</p>

      <p>9.2本服务条款构成您与我们的协议有效组成部分，规范您对本服务之使用。但在您使用相关服务、或使用第三方提供的内容或软件时，亦应遵从所适用之附加条款及权利。</p>

      <p>9.3 您对服务之任何部分或本服务条款的任何部分之意见及建议可通过邮件与我们联系，邮箱：kefu@hejingyouxi.com，我们保留本服务条款之解释权。</p>

    </div>
  )
})
